import React, { Component } from 'react'
import Included from '../Included'
import DarkThemeNav from '../common/dark-theme-nav';

class Drawers extends Component {

  constructor(props) {
    super(props)
  }

  render (){
    return(
      <section><a className="anchor" id="drawers"></a>
        <h2>Drawers</h2>
        <DarkThemeNav anchor="drawers" />

        <p>The drawer is similar to the modal component but it slides in from the left or right of the screen.</p>
        <p>The drawer spans the height of the screen. The width can be configured for non-mobile devices and will fill 100% width of mobile devices.</p>
        <p>A drawer by default will open and close from the <strong>right</strong> of the screen, this can be changed to the <strong>left</strong> of the screen by adding the class
        <code>.drawer__panel--left</code> to the panel element as documented below and shown in the examples code.</p>
        <p>There are two built in size variations applied through classes (documented below).</p>

        <table className="table table--comfy table--striped">
            <thead>
              <tr>
                <th className="text--left">Class</th>
                <th className="text--left">Description</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><code>.drawer__panel--sm</code></td>
                <td>Applies a width of 25% of the screen width to the drawer when open</td>
              </tr>
              <tr>
                <td><code>.drawer__panel--lg</code></td>
                <td>Applies a width of 50% of the screen width to the drawer when open</td>
              </tr>
              <tr>
                <td><code>.drawer__panel--xl</code></td>
                <td>Applies a width of 70% of the screen width to the drawer when open</td>
              </tr>
              <tr>
                <td><code>.drawer__panel--left</code></td>
                <td>Causes the drawer to open from the left of the screen</td>
              </tr>
            </tbody>
          </table>


        <aside className="example-drawer drawer" aria-hidden="true">
          <div className="drawer__panel">
            <button className="drawer__close btn btn--transparent js-drawer-close" aria-label="close">
              <i className="icon-cme-card-close icon--medium"></i>
            </button>
            <header className="drawer__header ">
              <h1 className="flush">Default drawer</h1>
            </header>
            <div className="drawer__body">
              Drawer contents here
            </div>
            <footer className="drawer__footer">
              <button type="button" className="btn btn--secondary js-drawer-close">Cancel</button>&nbsp;
              <button type="button" className="btn js-drawer-positive">OK</button>
            </footer>
          </div>
        </aside>

        <aside className="example-drawer-left-small drawer">
          <div className="drawer__panel drawer__panel--left drawer__panel--sm">
            <button className="drawer__close btn btn--transparent js-drawer-close" aria-label="close">
              <i className="icon-cme-card-close icon--medium"></i>
            </button>
            <header className="drawer__header">
              <h1 className="flush">Left drawer, small</h1>
            </header>
            <div className="drawer__body" role="dialog">
              Drawer contents here
            </div>
            <footer className="drawer__footer">
              <button type="button" className="btn btn--secondary js-drawer-close">Cancel</button>&nbsp;
              <button type="button" className="btn js-drawer-positive">OK</button>
            </footer>
          </div>
        </aside>

        <aside className="example-drawer-large drawer">
          <div className="drawer__panel drawer__panel--lg">
            <button className="drawer__close btn btn--transparent js-drawer-close" aria-label="close">
              <i className="icon-cme-card-close icon--medium"></i>
            </button>
            <header className="drawer__header">
              <h1 className="flush">Large drawer</h1>
            </header>
            <div className="drawer__body" role="dialog">
              Drawer contents here
            </div>
            <footer className="drawer__footer">
              <button type="button" className="btn btn--secondary js-drawer-close">Cancel</button>&nbsp;
              <button type="button" className="btn js-drawer-positive">OK</button>
            </footer>
          </div>
        </aside>

        <aside className="example-drawer-xlarge drawer">
          <div className="drawer__panel drawer__panel--xl">
            <button className="drawer__close btn btn--transparent js-drawer-close" aria-label="close">
              <i className="icon-cme-card-close icon--medium"></i>
            </button>
            <header className="drawer__header">
              <h1 className="flush">Extra Large drawer</h1>
            </header>
            <div className="drawer__body" role="dialog">
              Drawer contents here
            </div>
            <footer className="drawer__footer">
              <button type="button" className="btn btn--secondary js-drawer-close">Cancel</button>&nbsp;
              <button type="button" className="btn js-drawer-positive">OK</button>
            </footer>
          </div>
        </aside>

        <br/>

          <div className="display-inline-block">
            <button className="btn drawer-example-button push-quarter--ends">Drawer default example</button>
            &nbsp;<button className="btn drawer-left-small-example-button push-quarter--ends">Drawer left small example</button>
            &nbsp;<button className="btn drawer-large-example-button push-quarter--ends">Drawer large example</button>
            &nbsp;<button className="btn drawer-xlarge-example-button push-quarter--ends">Drawer extra large example</button>
          </div>

        <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
        <pre className="hide-code"><code className="language-html">{`
<aside class="example-drawer drawer">
  <div class="drawer__panel">
    <button class="drawer__close btn btn--transparent js-drawer-close" aria-label="close">
      <i class="icon-cme-card-close icon--medium"></i>
    </button>
    <header class="drawer__header">
      <h1 class="flush">Default drawer</h1>
    </header>
    <div class="drawer__body" role="dialog">
      Drawer contents here
    </div>
    <footer class="drawer__footer">
      <button type="button" class="btn btn--secondary js-drawer-close">Cancel</button>&nbsp;
      <button type="button" class="btn js-drawer-positive">OK</button>
    </footer>
  </div>
</aside>

<aside class="example-drawer-left-small drawer">
  <div class="drawer__panel drawer__panel--left drawer__panel--sm">
    <button class="drawer__close btn btn--transparent js-drawer-close" aria-label="close">
      <i class="icon-cme-card-close icon--medium"></i>
    </button>
    <header class="drawer__header">
      <h1 class="flush">Left drawer, small</h1>
    </header>
    <div class="drawer__body">
      Drawer contents here
    </div>
    <footer class="drawer__footer">
      <button type="button" class="btn btn--secondary js-drawer-close">Cancel</button>&nbsp;
      <button type="button" class="btn js-drawer-positive">OK</button>
    </footer>
  </div>
</aside>

<aside class="example-drawer-large drawer">
  <div class="drawer__panel drawer__panel--lg">
    <button class="drawer__close btn btn--transparent js-drawer-close" aria-label="close">
      <i class="icon-cme-card-close icon--medium"></i>
    </button>
    <header class="drawer__header">
      <h1 class="flush">Large drawer</h1>
    </header>
    <div class="drawer__body" role="dialog">
      Drawer contents here
    </div>
    <footer class="drawer__footer">
      <button type="button" class="btn btn--secondary js-drawer-close">Cancel</button>&nbsp;
      <button type="button" class="btn js-drawer-positive">OK</button>
    </footer>
  </div>
</aside>

<aside class="example-drawer-xlarge drawer">
  <div class="drawer__panel drawer__panel--xl">
    <button class="drawer__close btn btn--transparent js-drawer-close" aria-label="close">
      <i class="icon-cme-card-close icon--medium"></i>
    </button>
    <header class="drawer__header">
      <h1 class="flush">Extra Large drawer</h1>
    </header>
    <div class="drawer__body">
      Drawer contents here
    </div>
    <footer class="drawer__footer">
      <button type="button" class="btn btn--secondary js-drawer-close">Cancel</button>&nbsp;
      <button type="button" class="btn js-drawer-positive">OK</button>
    </footer>
  </div>
</aside>

<button class="btn drawer-example-button">Drawer example</button>
<button class="btn drawer-left-small-example-button">Drawer left small example</button>
<button class="btn drawer-large-example-button">Drawer large example</button>
<button class="btn drawer-xlarge-example-button">Drawer extra large example</button>
`}</code></pre>
<br/>
    <pre className="language-javascript"><code className="language-javascript">{`
commonUI.initializeDrawer(
  '.example-drawer',
  {
    trigger: '.drawer-example-button'
  }
);

commonUI.initializeDrawer(
  '.example-drawer-left-small',
  {
    trigger: '.drawer-left-small-example-button'
  }
);

commonUI.initializeDrawer(
  '.example-drawer-large',
  {
    trigger: '.drawer-large-example-button'
  }
);

commonUI.initializeDrawer(
  '.example-drawer-xlarge',
  {
    trigger: '.drawer-xlarge-example-button'
  }
);
`}</code></pre><br/><br/><br/>

        <h3>Programatic control</h3>
        <p>The drawer exposes open and close methods.</p>
        <code className="inline">{`var drawer = commonUI.initializeDrawer('.example-drawer');`}</code>
        <br/><br/>
        <table className="table table--striped table--comfy">
          <thead>
            <tr>
              <th className="text--left">Method</th>
              <th className="text--left">Description</th>
            </tr>
          </thead>
          <tbody>
          <tr>
            <td>drawer.open()</td>
            <td>Opens the drawer</td>
          </tr>
          <tr>
            <td>drawer.close()</td>
            <td>Closes the drawer, does not fire positive/negative events</td>
          </tr>
          <tr>
            <td>drawer.positive()</td>
            <td>Closes the drawer, fires positive event</td>
          </tr>
          <tr>
            <td>drawer.negative()</td>
            <td>Closes the drawer, fires negative event</td>
          </tr>
          </tbody>
        </table>
        <br/><br/>

        <h3>Events</h3>
        <p>The drawer exposes a few events for hooking into drawer functionality.</p>
        <table className="table table--striped table--comfy">
          <thead>
            <tr>
              <th className="text--left">Event</th>
              <th className="text--left">Description</th>
            </tr>
          </thead>
          <tbody>
          <tr>
            <td>show.commonui.drawer</td>
            <td>This event fires immediately when the open instance method is called.</td>
          </tr>
          <tr>
            <td>hide.commonui.drawer</td>
            <td>This event is fired immediately when the close instance method has been called.</td>
          </tr>
          <tr>
            <td>negative.commonui.drawer</td>
            <td>This event is fired when the user clicks a .js-drawer-close element</td>
          </tr>
          <tr>
            <td>positive.commonui.drawer</td>
            <td>This event is fired when the user clicks a .js-drawer-positive element</td>
          </tr>
          </tbody>
        </table>
        <br/>

        <aside className="example-drawer-events drawer">
          <div className="drawer__panel drawer__panel--small">
            <button className="drawer__close btn btn--transparent js-drawer-close" aria-label="close">
              <i className="icon-cme-card-close icon--medium"></i>
            </button>
            <header className="drawer__header">
              <h1 className="flush">Events Drawer</h1>
            </header>
            <div className="drawer__body" role="dialog">
              Drawer contents here
            </div>
            <footer className="drawer__footer">
              <button type="button" className="btn btn--secondary js-drawer-close">Cancel</button>&nbsp;
              <button type="button" className="btn js-drawer-positive">OK</button>
            </footer>
          </div>
        </aside>

        <button className="btn drawer-events-example-button">Events example</button>
      <br/><br/>
      <pre><code className="language-js">{`
commonUI.initializeDrawer(
  '.example-drawer-events',
  {
    trigger: '.drawer-events-example-button'
  }
);

var eventsDrawerExample = document.getElementsByClassName('example-drawer-events')[0];

eventsDrawerExample.addEventListener('show.commonui.drawer', function(){
    console.log('drawer show')
});
eventsDrawerExample.addEventListener('hide.commonui.drawer', function(){
    console.log('drawer hide')
});
eventsDrawerExample.addEventListener('positive.commonui.drawer', function(){
    console.log('drawer positive')
});
eventsDrawerExample.addEventListener('negative.commonui.drawer', function(){
    console.log('drawer negative')
});`}</code></pre><br/><br/>

        <h3>Tabbed Drawer</h3>
        <p>Tabbed drawers behave similiarly to the standard drawer component except they show a tab with an action attached to trigger the content reveal.</p>
        <table className="table table--comfy table--striped">
          <thead>
            <tr>
              <th className="text--left">Class</th>
              <th className="text--left">Description</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><code>.drawer__tabbed</code></td>
              <td>Applies tabbed styles and functionality to drawer component. This should be applied to the <code>aside</code> tag.</td>
            </tr>
            <tr>
              <td><code>.drawer__tabbed--bottom</code></td>
              <td>Aligns the tab to the bottom of the screen/container.</td>
            </tr>
          </tbody>
        </table>
        <p>Creating a tabbed drawer is similiar to the initiaisation of the default drawer component except you pass an attribute of <code>tabbed: true</code>.
        The trigger in this case is the revealed part of the drawer; the blue chevron button.</p>
        <pre><code className="language-js">{`commonUI.initializeDrawer('.example-drawer-tabbed', {
    tabbed: true,
    trigger: '.js-drawer-bottom-toggle'
});`}</code></pre><br/><br/>
        <aside id="tabbedDrawer" className="example-drawer-tabbed drawer drawer__tabbed drawer__tabbed--bottom hide" aria-hidden="true">
          <div className="drawer__toggle js-drawer-bottom-toggle" aria-label="toggle">
            <button className="btn btn--primary drawer__toggle__action">
              <i className="fa fa-chevron-up"></i>
            </button>
          </div>
          <div className="drawer__panel">
            <p className="drawer__panel--heading">Activity Log</p>
            <div className="drawer__body">
              <ul className="drawer__body__list">
                <li className="soft-quarter">Item 1</li>
                <li className="soft-quarter">Item 2</li>
                <li className="soft-quarter">Item 3</li>
                <li className="soft-quarter">Item 4</li>
                <li className="soft-quarter">Item 5</li>
                <li className="soft-quarter">Item 6</li>
                <li className="soft-quarter">Item 7</li>
                <li className="soft-quarter">Item 8</li>
                <li className="soft-quarter">Item 9</li>
                <li className="soft-quarter">Item 10</li>
              </ul>
            </div>
          </div>
        </aside>
        <aside id="tabbedDrawerAlt" className="example-drawer-tabbed-alt drawer drawer__tabbed drawer__tabbed--bottom hide" aria-hidden="true">
          <div className="drawer__toggle js-alt-drawer-bottom-toggle" aria-label="toggle">
            <button className="btn btn--primary drawer__toggle__action drawer__toggle__action--alt">
              <i className="fa fa-chevron-up"></i>
            </button>
          </div>
          <div className="drawer__panel">
            <p className="drawer__panel--heading">Activity Log</p>
            <div className="drawer__body">
              <ul className="drawer__body__list">
                <li className="soft-quarter">Item 1</li>
                <li className="soft-quarter">Item 2</li>
                <li className="soft-quarter">Item 3</li>
                <li className="soft-quarter">Item 4</li>
                <li className="soft-quarter">Item 5</li>
                <li className="soft-quarter">Item 6</li>
                <li className="soft-quarter">Item 7</li>
                <li className="soft-quarter">Item 8</li>
                <li className="soft-quarter">Item 9</li>
                <li className="soft-quarter">Item 10</li>
              </ul>
            </div>
          </div>
        </aside>

        <h3>Bottom Drawer Container Example</h3>

        <p>When open, the bottom drawer will fill 30% of its containing element.</p>

        <select className="size-select">
          <option value="1199">Select a resolution</option>
          <option value="479">480px (xs)</option>
          <option value="767">768px (sm)</option>
          <option value="991">992px (md)</option>
          <option value="1199">1200px (lg)</option>
        </select>

        <br/><br/>

        <div className="iframe-container" style={{
          "height":"600px"
        }}>
          <iframe seamless srcDoc={`
            <html class="height--100" style="background-color: #dedfe0">
              <head>
                <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">
                <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css"> 
                <link rel="stylesheet" type="text/css" href="css/commonUI.css">
              </head>
                <body class="height--100">
                  <aside id="tabbedDrawer" class="example-drawer-tabbed drawer drawer__tabbed drawer__tabbed--bottom" aria-hidden="true">
                    <div class="drawer__toggle js-drawer-bottom-toggle" aria-label="toggle">
                      <button class="btn btn--primary drawer__toggle__action">
                        <i class="fa fa-chevron-up"></i>
                      </button>
                    </div>
                    <div class="drawer__panel">
                      <p class="drawer__panel--heading">Activity Log</p>
                      <div class="drawer__body">
                        <ul class="drawer__body__list">
                          <li class="soft-quarter">Item 1</li>
                          <li class="soft-quarter">Item 2</li>
                          <li class="soft-quarter">Item 3</li>
                          <li class="soft-quarter">Item 4</li>
                          <li class="soft-quarter">Item 5</li>
                          <li class="soft-quarter">Item 6</li>
                          <li class="soft-quarter">Item 7</li>
                          <li class="soft-quarter">Item 8</li>
                          <li class="soft-quarter">Item 9</li>
                          <li class="soft-quarter">Item 10</li>
                        </ul>
                      </div>
                    </div>
                  </aside>
                  <script type="text/javascript" src="js/commonUI.js"></script>
                  <script>
                    function init() {
                      commonUI.initializeDrawer('.example-drawer-tabbed', {
                        tabbed: true,
                        trigger: '.js-drawer-bottom-toggle'
                      });
                    }
                    window.onload = init;
                  </script>
                </body>
              </html>
            `}>
          </iframe>
        </div>
        <br/><br/>
        <button className="btn push-quarter--ends" onClick={()=>{
          var tabbedDrawer = document.getElementById('tabbedDrawer'),
            tabbedDrawerAlt = document.getElementById('tabbedDrawerAlt')
          tabbedDrawerAlt.classList.add('hide');
          tabbedDrawer.classList.toggle('hide');
        }}>Toggle Tabbed Drawer</button>
        &nbsp;
        <button className="btn push-quarter--ends" onClick={()=>{
          var tabbedDrawer = document.getElementById('tabbedDrawer'),
            tabbedDrawerAlt = document.getElementById('tabbedDrawerAlt')
          tabbedDrawer.classList.add('hide');
          tabbedDrawerAlt.classList.toggle('hide');
        }}>Toggle Tabbed Drawer Alternative Button</button>
        <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
        <pre className="hide-code"><code className="language-html">{`<aside id="tabbedDrawer" class="example-drawer-tabbed drawer drawer__tabbed drawer__tabbed--bottom" aria-hidden="true">
  <div class="drawer__toggle js-drawer-bottom-toggle" aria-label="toggle">
    <button class="btn btn--primary drawer__toggle__action">
      <i class="fa fa-chevron-up"></i>
    </button>
  </div>
  <div class="drawer__panel">
    <p class="drawer__panel--heading">Activity Log</p>
    <div class="drawer__body">
      <ul class="drawer__body__list">
        <li class="soft-quarter">Item 1</li>
        <li class="soft-quarter">Item 2</li>
        <li class="soft-quarter">Item 3</li>
        <li class="soft-quarter">Item 4</li>
        <li class="soft-quarter">Item 5</li>
        <li class="soft-quarter">Item 6</li>
        <li class="soft-quarter">Item 7</li>
        <li class="soft-quarter">Item 8</li>
        <li class="soft-quarter">Item 9</li>
        <li class="soft-quarter">Item 10</li>
      </ul>
    </div>
  </div>
</aside>

<aside id="tabbedDrawerAlt" class="example-drawer-tabbed-alt drawer drawer__tabbed drawer__tabbed--bottom" aria-hidden="true">
  <div class="drawer__toggle js-alt-drawer-bottom-toggle" aria-label="toggle">
    <button class="btn btn--primary drawer__toggle__action drawer__toggle__action--alt">
      <i class="fa fa-chevron-up"></i>
    </button>
  </div>
  <div class="drawer__panel">
    <p class="drawer__panel--heading">Activity Log</p>
    <div class="drawer__body">
      <ul class="drawer__body__list">
        <li class="soft-quarter">Item 1</li>
        <li class="soft-quarter">Item 2</li>
        <li class="soft-quarter">Item 3</li>
        <li class="soft-quarter">Item 4</li>
        <li class="soft-quarter">Item 5</li>
        <li class="soft-quarter">Item 6</li>
        <li class="soft-quarter">Item 7</li>
        <li class="soft-quarter">Item 8</li>
        <li class="soft-quarter">Item 9</li>
        <li class="soft-quarter">Item 10</li>
      </ul>
    </div>
  </div>
</aside>`}</code></pre>
        <br/><br/><hr/>
      </section>
    )
  }
}

export default Drawers



// WEBPACK FOOTER //
// ./styleguide/components/sections/Drawers.js